import React, {Component, Fragment} from "react";
import SimpleModal from "../../../../../../modules/popup/SimpleModal";
import ModalContainer from "../../../../../../modules/commons/ModalContainer";
import SimpleInput from "../../../../../../modules/SimpleInput";
import SimpleButton from "../../../../../../modules/commons/SimpleButton";
import FlexView from "react-flexview";
import InventoryUnitTable from "../../common/InventoryUnitTable";
import SimpleDate from "../../../../../../modules/SimpleDate";
import InventoryUnitStockInfo from "./InventoryUnitStockInfo";
import Api from "../../../../../../Services/Api";
import { fetchDataAsync } from "../../../../../../Services/Utils";
import { HttpStatus } from "../../../../../common/Constants";
import moment from "moment";
import * as R from 'ramda'
import SimpleDataTable from "../../../../../../modules/SimpleDataTable";
import { defaultTableChange } from "../../../../../../modules/custom/customTable";
class InventoryUnitStock extends Component {
    tableConfig = [
        {
            name: "",
            label: "No",
            options: {
                customBodyRender: (_, tableMeta) => {
                    const {rowsPerPage} = tableMeta.tableState;
                    const rowNumber = 0 * rowsPerPage + tableMeta.rowIndex + 1
                    return <>{rowNumber}</>;
                },
                sort: false,
            },
        },
        {
            name: "date",
            label: "Tanggal",
            options: {
                sort: false,
            },
        },
        {
            name: "stock",
            label: "Awal",
            options: {
                sort: false,
            },
        },
        {
            name: "inBound",
            label: "Masuk",
            options: {
                customBodyRender: (value, tableMeta) => {
                    return (
                        <a
                            className="btnAct"
                            style={{textDecoration: 'underline', color: 'blue'}}
                            onClick={() => this.handleUnitStockInfoModalVisibility(tableMeta.rowIndex,'TRX_IN')}
                        >
                            {value}
                        </a>
                    );
                }
            },
        },
        {
            name: "outBound",
            label: "Keluar",
            options: {
                customBodyRender: (value, tableMeta) => {
                    return (
                        <a
                            className="btnAct"
                            style={{textDecoration: 'underline', color: 'blue'}}
                            onClick={() => this.handleUnitStockInfoModalVisibility(tableMeta.rowIndex,'TRX_OUT')}
                        >
                            {value}
                        </a>
                    );
                }
            },
        },
        {
            name: "balance",
            label: "Akhir",
            options: {
                sort: false,
            },
        },
    ]

    constructor(props) {
        super(props);
        this.initialSearch = {
            fromDate: moment().format("DD-MM-YYYY"),
            toDate: moment().format("DD-MM-YYYY"),
        }
        this.state = {
            unitStockInfoModalVisible: false,
            selectedData: null,
            dataTable: [],
            search: this.initialSearch,
            pagination: {
                page: 1,
                limit: 5,
                totalData: 0,
            },
        }
    }

    componentDidMount() {
        this.fetchData();
    }

    componentDidUpdate(prevProps, prevState) { 
        if(!R.equals(JSON.stringify(prevState.search),JSON.stringify(this.state.search))){
            this.fetchData()
        }
    } 

    handleUnitStockInfoModalVisibility = (index,trxType) => {
        this.setState((prevValue) => ({
            ...prevValue,
            selectedData: {...prevValue.dataTable[index],trxType},
            unitStockInfoModalVisible: !prevValue.unitStockInfoModalVisible,
        }));
    }

    handleDateChange = (name, value) => {
        this.setState((prevValue) => ({
            ...prevValue,
            data: {
                ...prevValue.data,
                [name]: value
            },
        }));
    };

    fetchData = async () => {
        try {
            const res = await fetchDataAsync({
              asyncFn: Api.create("NAGAMAS_TRANSACTION").getCardStockInventory,
              menuName: "Inventory Unit",
              setError: this.props.setError,
              args: {
                kodeCabang: Array.isArray(this.props.kodeCabang?.value) ? this.props.kodeCabang?.value[0] : this.props.kodeCabang?.value,
                locator: this.props.selectedData?.kodeLokasi,
                start: this.state.search.fromDate,
                end: this.state.search.toDate,
                variant: this.props.selectedData?.kodeVariant,
                colorCode: this.props.selectedData?.idWarna,
              },
            });
            if(res.ok && res.data.status === HttpStatus.SUCCESS){
                this.setState(prev=>({
                    ...prev,
                    dataTable:res.data.data,
                    pagination:{
                        ...prev.pagination,
                        totalData: res.data.data?.length
                    }
                }))
            }
        } catch (error) {
            console.log(error)
        }
    }

    handleChange = () =>{
        this.setState((prev) => ({
          ...prev,
          search: {
            fromDate: moment(this.state.data?.fromDate).format("DD-MM-YYYY"),
            toDate: moment(this.state.data?.toDate).format("DD-MM-YYYY"),
          },
        }));
    }

    handleChangePage = (tableState) => {
        this.setState((prevValue) => ({
            ...prevValue,
            pagination:{
                ...prevValue.pagination,
                page: tableState.page + 1,
            }
        }));
    };

    handleRowsPerPage = (tableState) => {
        this.setState((prevValue) => ({
            ...prevValue,
            pagination:{
                ...prevValue.pagination,
                page: 1,
                limit: tableState.rowsPerPage,
            }
        }));
    };

    render() {
        return (
          <Fragment>
            <SimpleModal
              title="Kartu Stock Unit Varian"
              visible={this.props.visible}
              onClickClose={() => this.props.onClickClose()}
              content={
                <ModalContainer>
                  <div className="grid grid-2x grid-mobile-none gap-20px margin-bottom-20px">
                    <div id="grid-1">
                      <SimpleInput
                        id="input_text_kode_variant"
                        name="kodeVariant"
                        label="Kode Varian"
                        readOnly={true}
                        value={this.props.selectedData.kodeVariant}
                      />
                      <SimpleInput
                        id="input_text_nama_variant"
                        name="namaVariant"
                        label="Nama Varian"
                        readOnly={true}
                        value={this.props.selectedData.namaVariant}
                      />
                    </div>

                    <div id="grid-2">
                      <SimpleInput
                        id="input_text_kode_warna"
                        name="kodeWarna"
                        label="Kode Warna"
                        readOnly={true}
                        value={this.props.selectedData.kodeWarna}
                      />
                      <SimpleInput
                        id="input_text_nama_warna"
                        name="namaWarna"
                        label="Nama Warna"
                        readOnly={true}
                        value={this.props.selectedData.namaWarna}
                      />
                    </div>
                  </div>

                  <FlexView style={{ justifyContent: "flex-end", gap: "10px" }}>
                    <SimpleDate
                      id="select_date_fromDate"
                      name="fromDate"
                      nextdate
                      maxDate={new Date()}
                      date={this.state.search.fromDate}
                      onChange={(value) =>
                        this.handleDateChange("fromDate", value)
                      }
                    />
                    <span className="margin-top-15px">s/d</span>
                    <SimpleDate
                      id="select_date_endDate"
                      name="endDate"
                      nextdate
                      maxDate={new Date()}
                      date={this.state.search.toDate}
                      onChange={(value) =>
                        this.handleDateChange("toDate", value)
                      }
                    />
                    <SimpleButton
                      className="margin-top-5px"
                      onClick={() => this.handleChange()}
                    >
                      Cari
                    </SimpleButton>
                  </FlexView>
                  <SimpleDataTable
                    key={`${this.state.pagination.totalData}-${this.state.pagination.page}`}
                    data={this.state.dataTable}
                    columns={this.tableConfig}
                    toCount={this.state.pagination.totalData}
                    rowsPerPage={this.state.pagination.limit}
                    page={this.state.pagination.page - 1}
                    options={{...defaultTableChange(this.handleChangePage, this.handleRowsPerPage), serverSide: false}}
                  />
                  <div style={{ textAlign: "right", marginTop: "10px" }}>
                    <SimpleButton
                      onClick={() => this.props.onClickClose()}
                      text={"Kembali"}
                    />
                  </div>
                </ModalContainer>
              }
            />

            {this.state.unitStockInfoModalVisible && (
              <InventoryUnitStockInfo
                selectedData={this.state.selectedData}
                dataUnit={{
                    ...this.props.selectedData,
                  kodeCabang: Array.isArray(this.props.kodeCabang?.value) ? this.props.kodeCabang?.value[0] : this.props.kodeCabang?.value,
                }}
                visible={this.state.unitStockInfoModalVisible}
                onClickClose={this.handleUnitStockInfoModalVisibility}
              />
            )}
          </Fragment>
        );
    }
}

export default InventoryUnitStock;